import appStore from 'store';
import api from './api';
import { PAGINATION } from 'common/config';
import LANGUAGE from 'common/languages';
const store = {
    namespaced: true,
    state: {
        pagination: PAGINATION,
        languageList: Object.keys(LANGUAGE).map(item => {
            return {
                value: Number(item),
                label: LANGUAGE[item]
            };
        }),
    },
    mutations: {},
    getters: {},
    actions: {}
}

appStore.registerModule('community', store);